module.exports = __webpack_public_path__ + "static/media/stubhub-bg.7a6e719e.jpg";